import React from "react";
import corns from "../../../assets/images/greenshine/corns.png";
import pel from "../../../assets/images/greenshine/pel.jpg";
import brokenrice from "../../../assets/images/greenshine/broken.jpg";
import rice from "../../../assets/images/greenshine/rice.jpg";
import sesame from "../../../assets/images/greenshine/sesameseeds.webp";
const Products = () => {
  const data = [
    {
      id: 1,
      img: corns,
    },
    {
      id: 2,
      img: pel,
    },

    {
      id: 3,
      img: rice,
    },

    {
      id: 4,
      img: brokenrice,
    },
    {
      id: 5,
      img: sesame ,
    },
  ];
  return (
    <div>
      <h1 className="text-center text-[36px] font-semibold titlefont">
        Our Product
      </h1>

      <div className=" flex flex-row flex-wrap gap-2 px-16 justify-evenly mt-14">
        {data.map((data) => (
          <div key={data.id} className="rounded-full md:w-32 md:h-32 w-20 h-20">
            <img
              src={data.img}
              className="rounded-full md:w-32 w-20 h-20  hover:scale-110 transition-all md:h-32 object-cover  "
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
